import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { formatNumber, DateFormatter } from '../../utils/date';
import forEach from 'lodash/forEach';
import Image from '../image/image';
import { casesRoute } from '../../routes/index';
import { Link } from 'react-router';
import pluralize from 'pluralize';

import css from './caseElement.scss';
import getCategoryName from '../../utils/getCategoryName';
import formatCredits from '../../utils/formatCredits';

//tmp
import img from './placeholder.png';

export default class CaseElementGeneric extends Component {
	static propTypes = {
		points: PropTypes.number.isRequired,
		showPoints: PropTypes.bool,
		showJudges: PropTypes.bool,
		profiles: PropTypes.array.isRequired,
		createdDate: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
		browser: PropTypes.object.isRequired,
		caseItem: PropTypes.object.isRequired,
		contentComp: PropTypes.oneOfType([
			PropTypes.oneOf([false]),
			PropTypes.func,
		]).isRequired,
	};
	static defaultProps = {
		points: 0,
		profiles: [],
		createdDate: '',
		categories: [],
		title: 'Unknown',
		showPoints: false,
		showJudges: false,
		contentComp: false,
	};

	constructor(props) {
		super(props);

		//this.testbg = `rgb(${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1})`;
		this.state = {
			readyClick: false,
		};
	}

	render() {
		let { caseItem, browser } = this.props;
		let ContentComp = this.props.contentComp;
		let url = casesRoute(caseItem.slug);

		let pointClass = 'span1 span2-mobile case-element__glitter-scorecard pixel-pattern';
		let imageClass = 'span3 span5-tablet span12-mobile case-element__glitter-img pixel-pattern pixel-pattern--dark';

		if (this.props.showPoints == 'true') {
			pointClass = 'span1 case-element__glitter-scorecard pixel-pattern';
			imageClass = 'span3 span5-tablet case-element__glitter-img span10-mobile pixel-pattern pixel-pattern--dark';
		}

		return (
			<div className='case-element'>
				<div className='case-element__glitter clearfix'>
					<div className={imageClass}>
						<Image img={caseItem.thumbnail} span={{ desktop: 'span3', tablet: 'span5', mobile: 'span12' }} alt='' browser={browser} />
						<div className='case-element__glitter-img__overlay' onClick={() => this.caseClick()}>
							<div className='case-element__glitter-img__overlay__aligner'>
								<Link to={url} className='button button--dark-to-light-anim' ref='seeCase' onClick={(event) => this.caseLaunchClick(event)}>See case</Link>
								<a href={caseItem.url} target='_blank' className='button button--light-to-dark-anim button--go' onClick={(event) => this.caseLaunchClick(event)}>Launch project</a>
							</div>
						</div>
					</div>
					<div className={pointClass}>
						{caseItem.legacy == 0 && (
							<div className='case-element__glitter-scorecard__score'>
								{formatNumber(caseItem.points)} <small>Points</small>
							</div>
						)}
						{caseItem.legacy == 0 && (
							<div className='case-element__glitter-scorecard__days'>
								{formatNumber(caseItem.days)} <small>Days</small>
							</div>
						)}

						{(caseItem.legacy == 0 && this.props.showJudges) && (
							<div className='case-element__glitter-scorecard__judges'>
								{formatNumber(caseItem.voteCount)} <small>{pluralize('Judges', caseItem.voteCount)}</small>
							</div>
						)}
					</div>
					<div className='cf'></div>
				</div>
				<div className='case-element__details-alt clearfix'>
					<div className='span3 span5-tablet case-element__details-alt-holder span12-mobile'>
						<Link to={url} className='case-element__details-alt__title'>
							<span className='case-element__details-alt__title__category'>{getCategoryName(caseItem.caseTypes, caseItem.bestViewedOn)}</span>
							{caseItem.title}
						</Link>
						<div className='case-element__details-alt__profile'>{formatCredits(caseItem.profiles, false)}</div>
						{ContentComp && (
							<ContentComp caseItem={caseItem} browser={this.props.browser} />
						)}
					</div>
					<div className='span1 hide-tablet empty'></div>
				</div>
			</div>
		);
	}

	caseLaunchClick(event) {
		if (this.props.browser.window.width < 720 && !this.state.readyClick) {
			event.preventDefault();
			this.setState({...this.state, readyClick: true});
		} else if (this.props.browser.window.width < 720) {
			this.setState({...this.state, readyClick: false});
		} else {
			event.stopPropagation();
		}
	}

	caseClick(event) {

		if (this.props.browser.window.width > 719) {
			ReactDOM.findDOMNode(this.refs.seeCase).click(event);
		} else {
			this.setState({...this.state, readyClick: true});
		}
	}

	getCaseTypes(caseTypes) {
		if (caseTypes && caseTypes.name) {
			return caseTypes.name;
		}

		return '';
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/case/caseElementGeneric.js
 **/